class ProductFarmboxForm extends HTMLElement {
    constructor() {
		super()

		this.isSubmitting = false
		this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer')
		this.addEventListener('submit', this.onSubmitHandler.bind(this))
		this.dataset.farmboxHandlerReady = 'true'

		this.formObserver = new MutationObserver(() => this.notifyAvailabilityChange())
		this.formObserver.observe(this, { childList: true, subtree: true })
		this.prepareCurrentForm()
		this.notifyAvailabilityChange()
	}

	disconnectedCallback() {
		if (this.formObserver) this.formObserver.disconnect()
	}

	getCurrentForm() {
		return this.querySelector('form[data-type="add-to-cart-form"]')
	}

	prepareCurrentForm() {
		const form = this.getCurrentForm()
		const submitButton = form && form.querySelector('[type="submit"]')
		if (submitButton && document.querySelector('cart-drawer')) {
			submitButton.setAttribute('aria-haspopup', 'dialog')
		}
	}

	notifyAvailabilityChange() {
		this.prepareCurrentForm()
		window.queueMicrotask(() => {
			if (window.ParadiseFarms && typeof window.ParadiseFarms.syncFarmboxMembershipAvailability === 'function') {
				window.ParadiseFarms.syncFarmboxMembershipAvailability()
			}
		})
	}

	onSubmitHandler(evt) {
		evt.preventDefault()
		const form = evt.target
		if (!form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return

		const submitButton = form.querySelector('[type="submit"]')
		const variantInput = form.querySelector('[name=id]')
		const spinner = form.querySelector('.loading-overlay__spinner')
		if (
			this.dataset.farmboxHandlerReady !== 'true'
			|| this.isSubmitting
			|| !submitButton
			|| !variantInput
			|| submitButton.disabled
			|| submitButton.getAttribute('aria-disabled') === 'true'
		) return

		const variantId = String(variantInput.value || '').trim()
		if (!/^\d+$/.test(variantId)) {
			this.handleErrorMessage('This product is currently unavailable.')
			return
		}

		this.handleErrorMessage();
		this.isSubmitting = true

		submitButton.setAttribute('aria-disabled', true)
		submitButton.disabled = true
		submitButton.classList.add('loading')
		if (spinner) spinner.classList.remove('hidden')

        const config = {
            method: 'POST',
            headers: {
                Accept: "application/json",
                'X-Requested-With': 'XMLHttpRequest',
            },
        };

		const formData = new FormData(form)
        const farmboxGroup = 'fbx-' + crypto.randomUUID();
		formData.set('properties[_farmbox_group]', farmboxGroup);
		
        if (this.cart) {
			formData.append(
				'sections',
				this.cart.getSectionsToRender().map((section) => section.id)
			)
			formData.append('sections_url', window.location.pathname)
            formData.append('_','')
			this.cart.setActiveElement(document.activeElement)
		}

		config.body = formData

		fetch(`${routes.cart_add_url}`, config)
			.then((response) => response.json())
			.then((response) => {
				if (response.status) {
					this.handleErrorMessage(response.description)

					const soldOutMessage = submitButton.querySelector('.sold-out-message')
					if (!soldOutMessage) return
						submitButton.setAttribute('aria-disabled', true)
						submitButton.querySelector('span').classList.add('hidden')
                        soldOutMessage.classList.remove('hidden')
                        this.error = true
					return
				} else if (!this.cart) {
					window.location = window.routes.cart_url
					return
				}

				this.error = false
				const quickAddModal = this.closest('quick-add-modal')
				if (quickAddModal) {
					document.body.addEventListener(
						'modalClosed',
						() => {
							setTimeout(() => {
								this.cart.renderContents(response)
							})
						},
						{ once: true }
					)
					quickAddModal.hide(true)
				} else {
					this.cart.renderContents(response)
				}
			})
			.catch((e) => {
				console.error(e)
			})
			.finally(() => {
				this.isSubmitting = false
				submitButton.classList.remove('loading')
				if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty')
				if (spinner) spinner.classList.add('hidden')
				if (!this.error && window.ParadiseFarms && typeof window.ParadiseFarms.syncFarmboxMembershipAvailability === 'function') {
					window.ParadiseFarms.syncFarmboxMembershipAvailability();
				} else if (!this.error) {
					submitButton.disabled = false
					submitButton.removeAttribute('aria-disabled')
				}
			})
	}

	handleErrorMessage(errorMessage = false) {
		const errorMessageWrapper = this.querySelector('.product-form__error-message-wrapper')
		if (!errorMessageWrapper) return
		const errorMessageElement = errorMessageWrapper.querySelector('.product-form__error-message')

		errorMessageWrapper.toggleAttribute('hidden', !errorMessage)

		if (errorMessage && errorMessageElement) {
			errorMessageElement.textContent = errorMessage
		}
	}
}

customElements.define(
  'product-farmbox-form',
  ProductFarmboxForm
);
